import { LoaderFunctionArgs } from "react-router-dom";
import { IResource } from "../type/IResource";
import { getResourceById } from "./getDataResourceById";

export default async function loaderResource({ params }: LoaderFunctionArgs): Promise<IResource | undefined> {
  const resource = getResourceById(params.id);

  return resource;
}